import { render, staticRenderFns } from "./ProductInstancesChips.component.vue?vue&type=template&id=266c7d9c&scoped=true&"
import script from "./ProductInstancesChips.component.vue?vue&type=script&lang=js&"
export * from "./ProductInstancesChips.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266c7d9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
